import React from 'react';
import { CheckCircle, X } from 'lucide-react';

export const ProWhiteLabel: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 leading-tight uppercase">
              Vos rapports, à votre image.
            </h2>
            <div className="w-12 h-0.5 bg-blue-500 mb-8"></div>

            <div className="space-y-4 text-gray-600 leading-relaxed mb-8">
              <p>
                Chaque analyse génère un rapport PDF complet, exportable en un clic. Avec l'offre Pro, ce rapport sort avec votre logo et le nom de votre entreprise.
              </p>
              <p>
                Vous le remettez à votre client en rendez-vous ou vous l'envoyez dans la foulée. <strong className="text-gray-800">C'est votre document, pas le nôtre.</strong>
              </p>
            </div>

            {/* Comparaison Standard vs Pro */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="rounded-xl border border-gray-200 bg-white p-4">
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Sans Pro</p>
                <div className="space-y-2 text-sm text-gray-500">
                  {[
                    "Logo DPEWizard",
                    "En-tête générique",
                    "Document non brandé"
                  ].map((item, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <X className="w-4 h-4 text-red-400 shrink-0" />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="rounded-xl border-2 border-blue-500 bg-blue-50 p-4">
                <p className="text-xs font-semibold text-blue-600 uppercase tracking-wide mb-3">Avec Pro Agence</p>
                <div className="space-y-2 text-sm text-gray-700">
                  {[
                    "Votre logo",
                    "Nom de votre agence",
                    "Prêt à remettre en RDV"
                  ].map((item, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-green-500 shrink-0" />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="space-y-3">
              {[
                "Export PDF en un clic, depuis n'importe quelle analyse",
                "Session de 30 min avec le fondateur pour démarrer",
                "1 compte partagé pour toute l'agence"
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex items-center justify-center">
            <div className="relative">
              <img
                src="/assets/DPEWizard_Rapport.png"
                alt="Exemple de rapport DPE avec branding professionnel"
                className="rounded-2xl shadow-xl max-w-sm w-full object-cover"
              />
              <div className="absolute -top-3 -right-3 bg-green-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md">
                Offre Pro
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProWhiteLabel;
